import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconMap from '../lib/icons/IconMap';
import cr1 from '../assets/carousel/cr-1.jpg';
import cr2 from '../assets/carousel/cr-2.jpg';
import img1 from '../assets/about/img1.jpg';
import img2 from '../assets/about/img2.jpg';

export const About = () => {

	// Feature cards data
	const features = [
		{
			icon: IconMap.faSchool,
			title: 'Convenient School Collection',
			description: 'Children are collected from Mucklagh National School at 2pm',
			iconColor: 'text-blue-500',
			bgColor: 'bg-blue-100',
			hoverBgColor: 'group-hover:bg-blue-500',
			hoverIconColor: 'group-hover:text-white'
		},
		{
			icon: IconMap.faClock,
			title: 'Flexible Afternoon Care',
			description: 'Supervised activities, play, and a safe environment until 3pm',
			iconColor: 'text-purple-500',
			bgColor: 'bg-purple-100',
			hoverBgColor: 'group-hover:bg-purple-500',
			hoverIconColor: 'group-hover:text-white'
		},
		{
			icon: IconMap.faWalking,
			title: 'School Drop-Off Service',
			description: 'Children are walked back to Mucklagh National School for the 3pm collection',
			iconColor: 'text-green-500',
			bgColor: 'bg-green-100',
			hoverBgColor: 'group-hover:bg-green-500',
			hoverIconColor: 'group-hover:text-white'
		},
		{
			icon: IconMap.faHome,
			title: 'Reduces Parent Pick-Ups',
			description: 'Parents with children finishing at different times only need one school collection',
			iconColor: 'text-orange-500',
			bgColor: 'bg-orange-100',
			hoverBgColor: 'group-hover:bg-orange-500',
			hoverIconColor: 'group-hover:text-white'
		},
		{
			icon: IconMap.faShieldAlt,
			title: 'Safe and Secure',
			description: 'Staff supervise children at all times during activities and the walk back to school',
			iconColor: 'text-blue-600',
			bgColor: 'bg-blue-100',
			hoverBgColor: 'group-hover:bg-blue-600',
			hoverIconColor: 'group-hover:text-white'
		},
		{
			icon: IconMap.faChild,
			title: 'Age-Appropriate Activities',
			description: 'Fun and engaging activities suited to the children\'s age group',
			iconColor: 'text-pink-500',
			bgColor: 'bg-pink-100',
			hoverBgColor: 'group-hover:bg-pink-500',
			hoverIconColor: 'group-hover:text-white'
		},
		{
			icon: IconMap.faUsers,
			title: 'Community-Focused',
			description: 'Supports busy families while maintaining a safe, caring environment',
			iconColor: 'text-red-500',
			bgColor: 'bg-red-100',
			hoverBgColor: 'group-hover:bg-red-500',
			hoverIconColor: 'group-hover:text-white'
		}
	];

	return (
		<div className="bg-white">
		<section id="about" className="py-16 px-4 sm:px-6 lg:px-8">
			<div className="body-container">
				{/* Section 2: Kindergarten - Split Screen */}
				<div className="py-16 px-4 sm:px-9 lg:px-8 rounded-xl">
					<div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
						{/* Images on Left - Grid Layout with Two Columns */}
					<div className="grid grid-cols-2 gap-4 lg:gap-6 mb-8 lg:mb-0">
						{/* First Image */}
						<div className="about-image-container">
							<div className="relative w-full h-full rounded-lg shadow-xl overflow-hidden bg-pink-50">
								<img
									src={img1}
									alt="Children"
									className="w-full h-full object-cover"
								/>
								{/* White gradient fade on the left */}
								<div className="about-image-gradient"></div>
							</div>
						</div>
						{/* Second Image */}
						<div className="about-image-container">
							<img
								src={img2}
								alt="Caregiver with child"
								className="w-full h-full object-cover rounded-lg shadow-2xl"
							/>
						</div>
					</div>

						{/* Content on Right */}
						<div className="lg:pl-8">
							<button className="button-offer mb-4">
								About Us
							</button>
							<p className="text-red-600 text-sm uppercase tracking-wider font-semibold mb-2">
								PART OF THE FAMILY SINCE 1998
							</p>
							{/* <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
								Two Generations, One Legacy of Passion, Shaping Life Long Memories.
							</h2> */}
							<p className="text-gray-600 text-base lg:text-lg leading-relaxed mb-6">
								We are constantly expanding the range of services offered, taking care of children of all ages. 
								Our goal is to carefully educate and develop children in a fun way. 
								We strive to turn the learning process into an exciting adventure that sparks curiosity and fosters a love for learning.
							</p>
							<p className="text-gray-600 text-base lg:text-lg leading-relaxed">
								Our dedicated team of educators creates a nurturing environment where every child can thrive, explore, and discover their unique talents and interests.
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
	);
};

export default About;
